import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';

interface Props {
  onClose(): void;
  onRetry?(): void;
}

export const EStatementPreferencesErrorModal: React.FC<Props> = ({ onClose, onRetry }) => {
  return (
    <Modal isOpen onRequestClose={onClose}>
      <ModalHeader>eStatement Preferences</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box my="56">
          <ErrorState onAction={onRetry} />
        </Box>
      </ModalBody>
    </Modal>
  );
};
